import React from 'react';

export interface LoadMoreButtonProps {
  text: string;
  isWhite?: boolean;
  isReversed?: boolean;
  onClick: Function;
  isLoading?: boolean;
  className?: string;
}

const LoadMoreButton = ({ text, onClick, isWhite, isReversed, isLoading, className }: LoadMoreButtonProps) => (
  <button
    type="button"
    disabled={isLoading}
    aria-busy={isLoading || undefined}
    className={`btn btn-load-more ${className || ''} ${isWhite ? 'white' : ''} ${isReversed ? 'reversed' : ''} ${
      isLoading ? 'loading' : ''
    }`}
    onClick={() => onClick()}
  >
    <div className="btn-content">
      <div className="custom-loader"></div>
      <span className="btn-text">{text}</span>
    </div>
  </button>
);

export default LoadMoreButton;
